import { getUserExpirationInfo } from "@shared/utils/misc";
import { useTheme } from "styled-components";
import { useState } from "react";
import { useUser } from "@shared/utils/hooks/misc";
import { AnalyticsPageName, LanguageNameSpaces } from "@shared/types";
import { useGetSubscriptionPlans } from "@shared/features/settings/subscription/hooks/misc";
import { getPlanErrorMessage } from "@shared/features/settings/subscription/utils";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface usePlanInfoProps {
  isWebview?: boolean;
}

const usePlanInfo = ({ isWebview }: usePlanInfoProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);
  const { user, isFetching: isFetchingUser } = useUser();
  const theme = useTheme();
  const isFree = user?.isFree();

  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [expirationAction, formattedExpiration] = getUserExpirationInfo(
    user,
    t
  );

  const { plans, isLoading } = useGetSubscriptionPlans();
  const showMobileAppWarning = user?.isNativeSubscription() && !isWebview;
  const extendPlanError = getPlanErrorMessage(
    plans,
    user?.subscription_plan_type,
    showMobileAppWarning,
    user
  );

  const getExpirationText = () => {
    return formattedExpiration
      ? `(${expirationAction} on ${formattedExpiration})`
      : undefined;
  };

  const isTrialHelperData = {
    analyticsPageName: AnalyticsPageName.BILLING,
    analyticsFieldName: "Trial Purchase Subscription",
    description: t("plan_info.trial_helper"),
    iconStyle: { marginRight: 8 },
  };

  const cancelSubscriptionModalProps = {
    visible: cancelModalOpen,
    closeModal: () => setCancelModalOpen(false),
  };

  return {
    user,
    theme,
    isFetchingUser,
    getExpirationText,
    setCancelModalOpen,
    isTrialHelperData,
    cancelSubscriptionModalProps,
    isFree,
    formattedExpiration,
    isLoading,
    extendPlanError,
  };
};

export default usePlanInfo;
